import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { WixConnect } from 'shared/utils/wix-connect';
import memoizedPartial from 'shared/utils/memoized-partial';

import Tab from './tab/tab';

import styles from './tabs.styl';


export const _propTypes = {
  tabs: React.PropTypes.arrayOf(React.PropTypes.string),
  content: React.PropTypes.arrayOf(React.PropTypes.any),
  currentTab: React.PropTypes.number,
  defaultTab: React.PropTypes.number,
  className: React.PropTypes.string,
  tabsClassName: React.PropTypes.string,
  contentClassName: React.PropTypes.string,
  tabClassName: React.PropTypes.string,
  activeTabClassName: React.PropTypes.string,
  onTabChange: React.PropTypes.func,
};

export const _defaultProps = {
  currentTab: 0,
  defaultTab: 0,
  onTabChange: _.noop,
};


export class BaseTabs extends React.Component {

  static propTypes = _propTypes;
  static defaultProps = _defaultProps;

  state = {
    shadowLeft: 0,
    shadowWidth: 0,
    shadowInnerMarginLeft: 0,
    shadowInnerWidth: 0,
    renderTrigger: false,
  };

  componentWillMount() {
    const { defaultTab, currentTab = defaultTab } = this.props;

    this.setCurrentTab(currentTab, false);
  }

  componentDidMount() {
    this.updateShadowTagPosition();
  }

  componentWillUpdate(nextProps) {
    const { currentTab } = nextProps;
    if (currentTab !== this.props.currentTab && currentTab !== this.state.currentTab) {
      this.setCurrentTab(currentTab, false);
    }
  }

  componentDidUpdate(nextProps, nextState) {
    const { renderTrigger } = this.state;

    if (renderTrigger === nextState.renderTrigger) {
      this.updateShadowTagPosition();
    }
  }

  tabRefs = {};

  updateShadowTagPosition() {
    const { currentTab, renderTrigger } = this.state;
    const { offsetLeft, offsetWidth } = this.tabRefs[currentTab];

    this.setState({
      shadowLeft: offsetLeft,
      shadowWidth: offsetWidth,
      shadowInnerMarginLeft: -offsetLeft,
      shadowInnerWidth: _.get(this, 'tabsWrapper.offsetWidth', 0),
      renderTrigger: !renderTrigger,
    });
  }

  @autobind
  setCurrentTab(index, runCallback = true) {
    const { onTabChange } = this.props;

    this.setState({
      currentTab: index,
    });

    if (runCallback) {
      onTabChange(index);
    }
  }

  @autobind
  saveTabRef(index, tab) {
    this.tabRefs[index] = tab;
  }

  get tabs() {
    const { tabs, tabsClassName, tabClassName, activeTabClassName } = this.props;
    const { shadowLeft, shadowWidth, shadowInnerMarginLeft, shadowInnerWidth } = this.state;
    const shadowTabClassNames = classnames(tabClassName, activeTabClassName);

    const shadowStyles = {
      left: `${shadowLeft}px`,
      width: `${shadowWidth}px`,
    };

    const shadowInnerStyles = {
      marginLeft: `${shadowInnerMarginLeft}px`,
      width: `${shadowInnerWidth}px`,
    };

    return (
      <section styleName="tabs-wrapper">
        <div styleName="shadow-wrapper"
             style={shadowStyles}
             ref={shadowWrapper => (this.shadowWrapper = shadowWrapper)}>
          <div styleName="tabs shadow-inner-wrapper"
               className={tabsClassName}
               style={shadowInnerStyles}
               ref={shadowInnerWrapper => (this.shadowInnerWrapper = shadowInnerWrapper)}>
            {
              _.map(tabs, tab => (
                <Tab key={tab}
                     className={shadowTabClassNames}
                     label={tab}
                     active />
              ))
            }
          </div>
        </div>
        <div styleName="tabs"
             className={tabsClassName}
             ref={tabsWrapper => (this.tabsWrapper = tabsWrapper)}>
          {
            _.map(tabs, (tab, index) => (
              <Tab key={tab}
                   className={tabClassName}
                   label={tab}
                   index={index}
                   onClick={this.setCurrentTab}
                   getRef={memoizedPartial(this.saveTabRef, index)} />
            ))
          }
        </div>
      </section>
    );
  }

  get tabsContent() {
    const { content, contentClassName } = this.props;
    const { currentTab } = this.state;

    return (
      <section styleName="content"
               className={contentClassName}>
        {
          _.map(content, (element, i) => React.cloneElement(element, {
            key: i,
            className: classnames({ [styles.hidden]: i !== currentTab }),
          }))
        }
      </section>
    );
  }

  render() {
    return null;
  }
}


@WixConnect(styles)
export default class Tabs extends BaseTabs {
  static displayName = 'Tabs';

  static propTypes = _propTypes;
  static defaultProps = _defaultProps;

  render() {
    const { className } = this.props;

    return (
      <section className={className}>
        {this.tabs}
        {this.tabsContent}
      </section>
    );
  }
}


@WixConnect(styles)
export class LazyTabs extends BaseTabs {
  static displayName = 'LazyTabs';

  static propTypes = _propTypes;
  static defaultProps = _defaultProps;

  get tabsContent() {
    const { content, contentClassName } = this.props;
    const { currentTab } = this.state;

    return (
      <section styleName="content"
               className={contentClassName}>
        {React.cloneElement(content[currentTab])}
      </section>
    );
  }

  render() {
    const { className } = this.props;

    return (
      <section styleName="wrapper"
               className={className}>
        {this.tabs}
        {this.tabsContent}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/tabs/tabs.js